// extracted by mini-css-extract-plugin
export default {"Switch":"AppForm_Switch__HumK6"};